
  import { computed, defineComponent } from 'vue';
  import { Button, Hint, Icon, Typography } from '@voximplant/spaceui';
  import { useI18n } from 'vue-i18n';
  import Loading from '@/components/animation/Loading.vue';
  import CallInfo from '@/components/calls/CallInfo.vue';
  import SplitButton from '@/components/buttons/SplitButton.vue';
  import DropdownList from '@/components/common/DropdownList.vue';
  import AudioCallFooter from '@/components/calls/AudioCallFooter.vue';
  import { $settings } from '@/store/settings/index';
  import {
    $callDuration,
    $calls,
    $currentSelectCallId,
    CALL_STATUSES,
    currentSelectCall,
  } from '@/store/calls/index';
  import { useStore } from 'effector-vue/composition';
  import { timeFormat } from '@/lib/Helpers';

  export default defineComponent({
    name: 'Call',
    components: {
      CallInfo,
      DropdownList,
      SplitButton,
      Loading,
      Typography,
      Button,
      Icon,
      Hint,
      AudioCallFooter,
    },
    setup() {
      const { t } = useI18n();
      const settingsState = useStore($settings);
      const selectCall = useStore(currentSelectCall);
      const currentSelectCallId = useStore($currentSelectCallId);
      const callDuration = useStore($callDuration);
      const calls = useStore($calls);
      const isRemoteMute = computed(() => calls.value[currentSelectCallId.value]?.params.muted);
      const errorText = computed(() =>
        selectCall.value && CALL_STATUSES.includes(selectCall.value?.status)
          ? t(`errors.${selectCall.value?.status}`)
          : selectCall.value?.status
      );
      const callClasses = computed(() => ({
        call: !settingsState.value.minimize,
        'call-collapsed': settingsState.value.minimize,
      }));

      return {
        t,
        selectCall,
        calls,
        timeFormat,
        callDuration,
        settingsState,
        errorText,
        isRemoteMute,
        callClasses,
      };
    },
  });
